import {
  faBoxTaped,
  faCircleDollar,
  faPenCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { FeedFallbackIcon, Icon } from 'corso-admin-ui';
import { CrewMerchantUi } from 'corso-types';
import { ReactNode } from 'react';

const eventTypeIconStyles = 'size-4 text-neutral-300';

export const timelineEventIcons: Readonly<
  Record<CrewMerchantUi.Timeline[number]['type'], ReactNode>
> = {
  simple: <FeedFallbackIcon />,
  email: <Icon icon="email" className={eventTypeIconStyles} />,
  shipment: <Icon icon={faBoxTaped} className={eventTypeIconStyles} />,
  processing: <Icon icon="success" className={eventTypeIconStyles} />,
  money: <Icon icon={faCircleDollar} className={eventTypeIconStyles} />,
  comment: <Icon icon="customer" className={eventTypeIconStyles} />,
  edit: <Icon icon={faPenCircle} className={eventTypeIconStyles} />,
  shopify: <Icon icon="shopify" className={eventTypeIconStyles} />,
  ai: <Icon icon="aiInline" className={eventTypeIconStyles} />,
  // a failure should stand out from the rest of the feed
  warning: <Icon icon="warning" className="size-4 text-amber-600" />,
} as const;
